import { render, staticRenderFns } from "./BulletinPrinter.vue?vue&type=template&id=4dcfc9e9&scoped=true&"
import script from "./BulletinPrinter.vue?vue&type=script&lang=js&"
export * from "./BulletinPrinter.vue?vue&type=script&lang=js&"
import style0 from "./BulletinPrinter.vue?vue&type=style&index=0&id=4dcfc9e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfc9e9",
  null
  
)

export default component.exports